import React from "react";
import AboutFirstLoad from "./functions/About.FirstLoad";
import AboutBanner from "./render/About.Banner";
import AboutList from "./render/About.List";
import MetaTags from "../../utils/useMetaTags";
import { ContextLanguage } from "../../context/Context.Language";

const AboutUsMain = () => {
  React.useEffect(() => {
    AboutFirstLoad();
  }, []);

  const { language } = React.useContext(ContextLanguage);

  return (
    <div id="scroll_about">
      {language === "TH" ? (
        <MetaTags
          title="เกี่ยวกับเรา - กรุงเทพ | My Laundry"
          description="My Laundry พิถีพิถันในคุณภาพ เราซักด้วย Bosch การใช้เครื่องซักผ้าที่ประหยัดพลังงานเป็นส่วนหนึ่งของความมุ่งมั่นที่เรามีต่อสิ่งแวดล้อม เรียนรู้เพิ่มเติม!"
        />
      ) : (
        <MetaTags
          title="About Us - Bangkok | My Laundry"
          description="My Laundry is dedicated to quality. WE WASH WITH BOSCH. Using energy-saving washing machines is part of our commitment to the environment. Learn more!"
        />
      )}
      <AboutBanner />
      <AboutList />
    </div>
  );
};
export default AboutUsMain;
